document.addEventListener("DOMContentLoaded", function () {
    // Immediately hide the banner (even before Shopify loads)
    let cookieBanner = document.querySelector("#shopify-pc__banner");
    if (cookieBanner) {
        cookieBanner.style.display = "none";
        cookieBanner.style.visibility = "hidden";
    }

    var tries = 0;
    function acceptCookiesShopify() {
        if (window.Shopify && Shopify.customerPrivacy) {
            Shopify.customerPrivacy.setTrackingConsent({
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: true
            });
        } else {
            if (++tries < 15) setTimeout(acceptCookiesShopify, 1000); // reintenta hasta ~15 s y para
        }
    }

    // Force Shopify to accept cookies immediately
    acceptCookiesShopify();

    // FREYVA (INP): antes había un setInterval que repetía esta llamada CADA SEGUNDO para siempre,
    // disparando trabajo y peticiones en el hilo principal durante toda la visita. Ya no hace falta:
    // acceptCookiesShopify() reintenta solo hasta que la API está lista y luego se detiene.
});
